import React, { useEffect } from 'react';
import { DLP_ITEMS } from '../../../../utils';
import DLPItemDetailsForm from './DLPItemDetailsForm';
import { regex } from '../../../../../../../../views/pages/manage/common/constant';
import styles from "../../../../styles.module.scss";
import { getFormattedAmount } from '../../../../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

const DLP_REFUND_FORM_FIELDS = [
    "Items",
    "Refund % Breakup",
    "Fees after breakup",
    "Total Qty",
    "Per unit cost",
    "Qty utilised",
    "Qty remaining",
    "Utilised Amount"
]

const DataCell = ({ label, value }) => (
    <div className='d-flex flex-column'>
        <div>{label}</div>
        <div><b>{getFormattedAmount(value)}</b></div>
    </div>
)

const roundOffTo2Decimals = val => Number(val.toFixed(2));

const extractDlpFeeDetails = (data, feeBreakupWithTaxDetails) => {


    const courseFeeBaseAmount = data?.grossAmount ?? 0;

    const {totalTaxPercentage} = feeBreakupWithTaxDetails?.[0] ?? {};

    const getPayableAmountWithTax = (amount) => {
        const val = amount + ((amount * totalTaxPercentage)/100);
        return Math.round(val);
    }

    const findByLastDigits = (digits) =>
        data?.feeSummaryDTOList?.find(item =>
            item?.minimumItemType?.endsWith(digits)
        );

    const regItem = findByLastDigits("29");
    const dlpItem = findByLastDigits("13");

    const regFeeBaseAmount =
        regItem?.feeBreakupDTOList?.[0]?.grossAmount ?? 0;

    const dlpCourseFeeBaseAmount =
        dlpItem?.feeBreakupDTOList?.[0]?.grossAmount ?? 0;

    const dlpCourseFeePaid =
        dlpItem?.feeBreakupDTOList?.[0]?.paidAmount ?? 0;

    return {
        courseFee : getPayableAmountWithTax(courseFeeBaseAmount),
        regFee : getPayableAmountWithTax(regFeeBaseAmount),
        dlpCourseFee : getPayableAmountWithTax(dlpCourseFeeBaseAmount),
        dlpCourseFeePaid,
        // netRefundableAmount: dlpCourseFeePaid
    };
};


const DLPWithdrwalRefundForm = ({
    dlpWithdrawalRefundDetails,
    setRefundDetailsForm,
    studentDetails = {},
    // studentFeeBreakup,
    viewOnly = false,
    disableFormFields = false
    // styles
}) => {

    const {studentFeeBreakup , feeBreakupWithTaxDetails} = studentDetails;

    useEffect(() => {
        !viewOnly && setRefundDetailsForm(prev => {
            const dlpFeeDetails = extractDlpFeeDetails(studentFeeBreakup, feeBreakupWithTaxDetails);
            return({
            ...prev,
            dlpWithdrawalRefundDetails: {
                ...(prev?.dlpWithdrawalRefundDetails ?? {}),
                // ...extractDlpFeeDetails(studentFeeBreakup)
                ...dlpFeeDetails
            }

        })})
    }, [studentFeeBreakup])

    console.log('studentFeeBreakup', studentFeeBreakup);


    const handleForm = (dlpItemKey, fieldKey, val) => {

        if (!regex.numeric.test(val)) return;

        setRefundDetailsForm(prev => {
            const { dlpWithdrawalRefundDetails = {} } = prev;
            const prevItem = dlpWithdrawalRefundDetails[dlpItemKey] ?? {};

            let updatedItem = {
                ...prevItem,
                [fieldKey]: val,
                items: dlpItemKey,
            };

            let {
                refundPercentage = 0,
                totalQty = 0,
                qtyUtilised = 0,
            } = updatedItem;


            if (fieldKey === "refundPercentage") {
                const refundPercentage =
                    DLP_ITEMS.reduce((acc, curr) => {
                        return acc +
                            (dlpWithdrawalRefundDetails?.[curr.value]?.refundPercentage ?? 0);
                    }, 0) -
                    (prevItem.refundPercentage ?? 0) +
                    val;

                if (refundPercentage > 100) return prev;
            }

            if (fieldKey === "qtyUtilised" && val > totalQty) return prev;

            if (fieldKey === "totalQty" && qtyUtilised > val) {
                qtyUtilised = val;
            }


            const itemsFee = roundOffTo2Decimals(
                dlpCourseFee * refundPercentage / 100
            );

            const perUnitCost =
                totalQty > 0 ? roundOffTo2Decimals(itemsFee / totalQty) : 0;

            const qtyRemaining = Math.max(totalQty - qtyUtilised, 0);

            const utilisedAmount = roundOffTo2Decimals(
                perUnitCost * qtyUtilised
            );

            const nextItems = {
                ...dlpWithdrawalRefundDetails,
                [dlpItemKey]: {
                    ...updatedItem,
                    qtyUtilised,
                    itemsFee,
                    perUnitCost,
                    qtyRemaining,
                    utilisedAmount
                }
            };


            const totalUtilisedAmount = roundOffTo2Decimals(
                Object.values(nextItems).reduce((sum, item) => {
                    return sum + (item?.utilisedAmount ?? 0);
                }, 0)
            );

            const netRefundableAmount = Math.max(
                dlpCourseFeePaid - totalUtilisedAmount,
                0
            );

            const totalRefundPercentage = DLP_ITEMS.reduce((acc, curr) => {
                return acc +
                    (nextItems?.[curr.value]?.refundPercentage ?? 0);
            }, 0)

            return {
                ...prev,
                dlpWithdrawalRefundDetails: {
                    ...nextItems,

                    // courseFee,
                    // regFee,
                    // dlpCourseFee,
                    // dlpCourseFeePaid,

                    totalUtilisedAmount,
                    netRefundableAmount,
                    totalRefundPercentage
                }
            };
        });
    };

    const { totalUtilisedAmount = 0, netRefundableAmount = 0, courseFee, dlpCourseFee, regFee, dlpCourseFeePaid } = dlpWithdrawalRefundDetails;


    return (
        <div className={styles['dlp-withdrwal-refund-form']}>

            <div className={styles['dlp-course-details']}>
                <span><b>Total Course Fees : {getFormattedAmount(courseFee)}</b></span>
                <span>DLP Course Fees : {getFormattedAmount(dlpCourseFee)}</span>
                <span>Registration Fees : {getFormattedAmount(regFee)}</span>
            </div>

            <div className={styles['table-container']}>

                <table>
                    <tbody>
                        <tr>
                            {DLP_REFUND_FORM_FIELDS?.map(field => <th key={field}>{field}</th>)}
                        </tr>
                        {DLP_ITEMS?.map(item =>
                            <DLPItemDetailsForm
                                key={item.value}
                                itemLabel={item.label}
                                itemKey={item.value}
                                handleForm={handleForm}
                                itemDetails={dlpWithdrawalRefundDetails[item.value] ?? {}}
                                viewOnly={viewOnly}
                                disableFormFields={disableFormFields}
                            />
                        )}
                    </tbody>

                </table>
            </div>

            <div className='d-flex' style={{ gap: '1rem' }}>
                <DataCell
                    label="Actual DLP Course Fees (Student Paid)"
                    value={dlpCourseFeePaid}
                />

                <DataCell
                    label="Total Utilised Amount"
                    value={totalUtilisedAmount}
                />

                <DataCell
                    label="Net Refund Amount"
                    value={netRefundableAmount}
                />

            </div>
        </div>
    );
}

export default DLPWithdrwalRefundForm;